import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.FileDropArea', {
    dropHereText: 'Drop the files here',
});
